import { Theme } from '@mui/material/styles';
import { makeAutoObservable } from 'mobx'
import { Unsubscribe } from 'redux';
import i18n, { Resources } from '../i18n';
import { autoSet } from '../modules/cache/auto-set-storage';
import { LOCAL_STORAGE_KEYS } from '../modules/cache/local-storage.constant';
import LSM from '../modules/cache/tool-local-storage';
import { DefaultWebsocketClient } from '../modules/websocket/module';
import themes from '../themes';
import { CutomizationPaletteMode } from '../themes/customization';

export class AppPageState implements IAppPageState {

    constructor() {
        this.language = LSM.get(LOCAL_STORAGE_KEYS.LANGUAGE)
        makeAutoObservable(this)
    }

    // 主题
    theme: Theme = themes('light');
    // 加载中
    loading: boolean = false;
    // 主题模式
    themesMode: CutomizationPaletteMode = 'light';
    // redux store 监听
    unsubscribe: Unsubscribe | null = null;
    // 语言
    language: Resources = 'CN';
    /**
     * 初始化
     */
    setConfig = () => {
        this.addListeners();
    }

    /**
     * 销毁
     */
    destroy = () => {
        DefaultWebsocketClient?.removeAllListeners();
        i18n.off('languageChanged');
    }

    @autoSet(LOCAL_STORAGE_KEYS.LANGUAGE)
    updateLanguage(lang: Resources) {
        this.language = lang
    }

    /**
     * 添加监听
     */
    addListeners = () => {
        // 监听主题变化
        DefaultWebsocketClient?.on('SWITCH_THEME', this.switchThemeMode);

        // 监听国际化变化
        i18n.on('languageChanged', (lng: Resources) => {
            this.updateLanguage(lng);
        });
    }

    /**
     * 切换主题模式
     */
    switchThemeMode = () => {
        const NthemesMode = this.themesMode === 'dark' ? 'light' : 'dark';
        this.themesMode = NthemesMode;
        this.theme = themes(NthemesMode);
    }
}

interface IAppPageState {
    theme: Theme
    loading: boolean;
    unsubscribe: Unsubscribe | null;
    themesMode: CutomizationPaletteMode
}